import type { Resolvers } from '@apollo/client'

import { postCheckBrowserId } from '../api/browser_id'

const BrowserIDResolvers: Resolvers = {
  Mutation: {
    postBrowserId: async (_, { useClientApi }) => {
      await postCheckBrowserId(useClientApi)
    },
  },
}

export default BrowserIDResolvers
